document.addEventListener('DOMContentLoaded', code);

if (window.acf) {
  window.acf.addAction('render_block_preview/type=faqs-block', code);
}

function code(event) {
  document.addEventListener('click', function (event) {
    // If the clicked element isn't the to accordion trigger, return
    if (!event.target.matches('.accordion-trigger')) return;
    var aria = event.target.getAttribute('aria-expanded'); // get attribute of target clicked

    if (aria == 'true') {
      aria = 'false';
    } else {
      aria = 'true';
    }

    event.target.classList.toggle('accordion-open'); //add the open class

    event.target.setAttribute('aria-expanded', aria); //change aria-expanded
  }, false);
}